import { render, staticRenderFns } from "./cell-promo-code-validity.vue?vue&type=template&id=71705944&scoped=true"
import script from "./cell-promo-code-validity.ts?vue&type=script&lang=ts&external"
export * from "./cell-promo-code-validity.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-promo-code-validity.vue?vue&type=style&index=0&id=71705944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71705944",
  null
  
)

export default component.exports